import { calcShiftDurationHours, formatTime12 } from "./rosterUtils";
import { rosterTheme as t } from "./rosterTheme";

export default function ShiftPreviewCard({ shift }) {
  if (!shift) {
    return (
      <div className={`${t.card} border-dashed p-4 text-sm text-slate-500 bg-slate-50/80`}>
        Select a shift to preview timing and rules.
      </div>
    );
  }

  const totalHours =
    shift.total_hours ??
    calcShiftDurationHours(shift.start_time, shift.end_time, shift.break_minutes);

  return (
    <div className="rounded-xl border border-teal-100 bg-gradient-to-br from-teal-50/90 to-white p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h3 className="font-semibold text-gray-900">{shift.name}</h3>
          <p className="text-sm text-gray-600 mt-1">
            {formatTime12(shift.start_time)} – {formatTime12(shift.end_time)}
          </p>
        </div>
        <div className="flex flex-wrap gap-1 justify-end">
          {shift.cross_midnight && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-violet-100 text-violet-800">
              Overnight
            </span>
          )}
          {shift.night_shift && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-indigo-100 text-indigo-800">
              Night
            </span>
          )}
          {shift.is_weekly_off && (
            <span className="text-xs px-2 py-0.5 rounded-full bg-slate-200 text-slate-700">
              Weekly off
            </span>
          )}
        </div>
      </div>
      <dl className="mt-3 grid grid-cols-2 gap-2 text-sm">
        <div>
          <dt className="text-gray-500">Break</dt>
          <dd className="font-medium">{shift.break_minutes ?? 0} min</dd>
        </div>
        <div>
          <dt className="text-gray-500">Total hours</dt>
          <dd className="font-medium">{totalHours ?? "—"}</dd>
        </div>
      </dl>
    </div>
  );
}
